export const actionGenerator = (constantVariables) => constantVariables.map(constantVariable => (payload) => ({ type: constantVariable, payload }))

export const constGenerator = (moduleName, actionConst) => ({
    [actionConst]: moduleName + "/" + actionConst,
    [actionConst + "_SUCCESS"]: moduleName + "/" + actionConst + "_SUCCESS",
    [actionConst + "_FAILURE"]: moduleName + "/" + moduleName + "/" + actionConst + "_FAILURE",
})
